import React from 'react';
import { Helmet } from 'react-helmet-async';
interface SEOProps {
  title: string;
  description: string;
  canonicalUrl?: string;
  ogImage?: string;
  ogType?: string;
  schema?: React.ReactNode;
  keywords?: string;
  author?: string;
  noIndex?: boolean;
  noFollow?: boolean;
  children?: React.ReactNode;
}
export const SEO: React.FC<SEOProps> = ({
  title,
  description,
  canonicalUrl,
  ogImage = 'https://uploadthingy.s3.us-west-1.amazonaws.com/1JGevbSoLh1AeBrRR9hz3Q/IMG_1783.jpg',
  ogType = 'website',
  schema,
  keywords,
  author = 'AIR-MAZING AIR, INC.',
  noIndex = false,
  noFollow = false,
  children
}) => {
  const siteUrl = 'https://airmazingair.com'; // Replace with your actual domain
  const fullUrl = canonicalUrl ? `${siteUrl}${canonicalUrl}` : siteUrl;
  const fullTitle = `${title} | AIR-MAZING AIR, INC.`;
  return <Helmet data-id="element-286">
      {/* Basic Meta Tags */}
      <title data-id="element-287">{fullTitle}</title>
      <meta name="description" content={description} data-id="element-288" />
      <meta name="viewport" content="width=device-width, initial-scale=1" data-id="element-289" />
      {/* Author */}
      {author && <meta name="author" content={author} data-id="element-290" />}
      {/* Keywords */}
      {keywords && <meta name="keywords" content={keywords} data-id="element-291" />}
      {/* Robots */}
      {(noIndex || noFollow) && <meta name="robots" content={`${noIndex ? 'noindex' : 'index'}, ${noFollow ? 'nofollow' : 'follow'}`} data-id="element-292" />}
      {/* Canonical URL */}
      {canonicalUrl && <link rel="canonical" href={fullUrl} data-id="element-293" />}
      {/* Open Graph / Facebook */}
      <meta property="og:type" content={ogType} data-id="element-294" />
      <meta property="og:url" content={fullUrl} data-id="element-295" />
      <meta property="og:title" content={fullTitle} data-id="element-296" />
      <meta property="og:description" content={description} data-id="element-297" />
      <meta property="og:image" content={ogImage} data-id="element-298" />
      <meta property="og:site_name" content="AIR-MAZING AIR, INC." data-id="element-299" />
      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" data-id="element-300" />
      <meta name="twitter:title" content={fullTitle} data-id="element-301" />
      <meta name="twitter:description" content={description} data-id="element-302" />
      <meta name="twitter:image" content={ogImage} data-id="element-303" />
      {/* Structured Data */}
      {schema && <script type="application/ld+json" data-id="element-304">{JSON.stringify(schema)}</script>}
      {/* Allow for additional custom meta tags */}
      {children}
    </Helmet>;
};